import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-login">
      <form className="admin-card" onSubmit={submit} data-testid="admin-login-form">
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
          <span className="logo-mark">CD</span>
          <div className="logo-text"><b style={{ fontSize: 17 }}>Cerebral Diagnostics</b><span style={{ color: "var(--brand)" }}>Admin CMS</span></div>
        </div>
        <h1>Sign in</h1>
        <p className="sub">Manage News, Investor Relations and contact messages.</p>
        {err && <div className="form-msg err" data-testid="login-error">{err}</div>}
        <div className="field">
          <label>Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" placeholder="admin@cerebraldiagnostics.com" />
        </div>
        <div className="field">
          <label>Password</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" placeholder="Password" />
        </div>
        <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center" }} disabled={busy} data-testid="login-submit" type="submit">
          {busy ? "Signing in..." : "Sign in"}
        </button>
        <p style={{ textAlign: "center", marginTop: 20, fontSize: 13.5 }}><Link to="/" style={{ color: "var(--muted)" }}>Back to site</Link></p>
      </form>
    </div>
  );
}
